import {BASE_LAYERS} from '@apps-common/ui-maps/constants';

export const OVERLAYS = {
  ...BASE_LAYERS,
  LABELS: 'labels',
  CENTER_MARKER: 'centerMarker',
};

export const DEFAULT_OVERLAYS = {
  [OVERLAYS.LABELS]: true,
  [OVERLAYS.CENTER_MARKER]: false,
};
